export const preloadedValuesEvento = {
  psEvRecStatus: false,
  psEvObservacao:""
};